import { create } from 'zustand';

interface CommandPaletteState {
    open: boolean;
    setOpen: (open: boolean) => void;
}

/**
 * Shared ⌘K palette open-state.
 *
 * Lives in its own module (rather than next to <CommandPalette>) so
 * non-component consumers — notably the global trading shortcuts, which must
 * stand down while the palette has focus — can read it without importing the
 * whole dialog component tree.
 */
export const useCommandPaletteState = create<CommandPaletteState>((set) => ({
    open: false,
    setOpen: (open) => set({ open }),
}));
